<template>
  <vs-prompt buttons-hidden title="Create Order Shipment" :active="showCreateOrderShipmentDialog" @close="close" class="create-order-shipment-dialog">
    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <vs-alert title="" :active="error" color="danger">{{ error }}</vs-alert>
    <template v-if="order">
      <vs-table ref="table" class="pb-5" :data="lineItems">
        <template slot="thead">
          <vs-th v-for="(header, index) in headers"  :key="`header-${index}`" >
            {{ header }}
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody v-for="(lineItem, index) in data" :data="lineItems" :key="index">
          <vs-tr class="cursor-pointer">
            <vs-td>
              <p class="font-medium truncate">{{ lineItem.sku }}</p>
            </vs-td>
            <vs-td>
              <p class="font-medium truncate">{{ lineItem.name }}</p>
            </vs-td>
            <vs-td>
              <vs-select v-model="lineItem.fulfillmentCenterId">
                <vs-select-item
                  v-for="(fulfillmentCenter, idx) in fulfillmentCenters"
                  :key="`fulfillmentCenter-${index}-${idx}`"
                  :value="fulfillmentCenter._id"
                  :text="fulfillmentCenter.name"
                />
              </vs-select>
            </vs-td>
          </vs-tr>
          </tbody>
        </template>

      </vs-table>
      <div class="vx-row">
        <div class="vx-col w-full my-2">
          <vs-button
            class="float-right"
            color="primary"
            type="border"
            :disabled="loading"
            @click="createShipment"
          >
            Yes
          </vs-button>
          <vs-button
            class="float-right mr-2"
            color="primary"
            @click="close"
            :disabled="loading"
          >
            No
          </vs-button>
        </div>
      </div>
    </template>
  </vs-prompt>
</template>

<style lang="scss">
  .create-order-shipment-dialog{
    .vs-dialog {
      max-width: 950px;
    }
  }
</style>

<script>
import api from "@/http/api";

  export default {
    props: [
      'order',
      'refresh',
      'showCreateOrderShipmentDialog'
    ],
    data() {
      return {
        headers: ["Sku", "Name", "Location"],
        error: null,
        loading: false,
        lineItems: [],
        fulfillmentCenters: []
      }
    },
    mounted() {
      this.order.lineItems.forEach(lineItem => {
        if (!lineItem.requiresShipping) return;
        this.lineItems.push({...lineItem, fulfillmentCenterId: null});
      });
      this.getFulfillmentCenters();
    },
    methods: {
      async createShipment() {
        this.error = null;
        this.loading = true;

        if (this.lineItems.filter(lineItem => !lineItem.fulfillmentCenterId ).length) {
          this.error = "One or more line items missing a fulfillment center.";
          this.loading = false;
          return;
        }

        const success = await api.createOrderShipments(this.order._id, this.lineItems);
        this.loading = false;
        if (!success) return this.error = "Could not create shipment records";

        await this.refresh();
        this.close();
      },
      async getFulfillmentCenters() {
        this.fulfillmentCenters = await api.getAllFulfillmentCenters();
      },
      close() {
        this.error = false;
        this.$emit('update:showCreateOrderShipmentDialog', false);
      },
    }
  }
</script>
